import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import toast from 'react-hot-toast';
import './Personnel.css';
import './Dashboard.css';

const Approvals = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [pendingUsers, setPendingUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [processingId, setProcessingId] = useState(null);

  // الأدوار المسموح لها بالموافقة/الرفض
  const canApprove = user && ['technician', 'engineer', 'supervisor', 'senior', 'admin'].includes(user.role);

  // جلب المستخدمين المعلقين
  const fetchPendingUsers = async () => {
    try {
      setLoading(true);
      
      // التأكد من وجود token
      const token = localStorage.getItem('token');
      if (token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      }
      
      const response = await axios.get('/api/users/pending');
      setPendingUsers(response.data.data.users);
    } catch (error) {
      toast.error('فشل في تحميل الطلبات');
      console.error('Error fetching pending users:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPendingUsers();
  }, []);

  // الموافقة على المستخدم
  const handleApprove = async (userId) => {
    if (!canApprove) {
      toast.error('ليس لديك صلاحية للموافقة');
      return;
    }

    try {
      setProcessingId(userId);
      await axios.patch(`/api/users/${userId}/approve`);
      toast.success('تم قبول الطلب بنجاح');
      
      // إزالة المستخدم من القائمة
      setPendingUsers(prev => prev.filter(u => u._id !== userId));
    } catch (error) {
      toast.error(error.response?.data?.message || 'فشل في قبول الطلب');
    } finally {
      setProcessingId(null);
    }
  };

  // رفض المستخدم
  const handleReject = async (userId) => {
    if (!canApprove) {
      toast.error('ليس لديك صلاحية للرفض');
      return;
    }

    try {
      setProcessingId(userId);
      await axios.patch(`/api/users/${userId}/reject`);
      toast.success('تم رفض الطلب');
      
      // إزالة المستخدم من القائمة
      setPendingUsers(prev => prev.filter(u => u._id !== userId));
    } catch (error) {
      toast.error(error.response?.data?.message || 'فشل في رفض الطلب');
    } finally {
      setProcessingId(null);
    }
  };

  // ترجمة الأدوار
  const getRoleLabel = (role) => {
    const roles = {
      'technician': 'فني',
      'engineer': 'مهندس',
      'supervisor': 'سوبر فايزر',
      'senior': 'سنيور',
      'assistant': 'مساعد',
      'admin': 'الإدارة'
    };
    return roles[role] || role;
  };

  if (loading) {
    return (
      <div className="personnel-container">
        <div style={{ marginBottom: '30px', display: 'flex', justifyContent: 'center' }}>
          <button 
            onClick={() => navigate('/personnel')} 
            style={{
              background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)',
              border: 'none',
              color: 'white',
              padding: '16px 40px',
              borderRadius: '12px',
              fontSize: '1.2rem',
              fontWeight: '700',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 15px rgba(52, 152, 219, 0.3)',
              minWidth: '250px',
              justifyContent: 'center'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-3px) translateX(5px)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(52, 152, 219, 0.4)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0) translateX(0)';
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(52, 152, 219, 0.3)';
            }}
          >
            <span style={{ fontSize: '1.4rem' }}>←</span>
            <span>العودة للأفراد</span>
          </button>
        </div>
        
        <div style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          padding: '40px',
          borderRadius: '15px',
          marginBottom: '30px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.15)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '10px' }}>
            <span style={{ fontSize: '2.5rem' }}>🔔</span>
            <h1 style={{ 
              fontSize: '2.2rem', 
              fontWeight: '700', 
              color: 'white',
              margin: 0,
              letterSpacing: '0.5px'
            }}>
              طلبات الانضمام
            </h1>
          </div>
          <p style={{ 
            fontSize: '1.1rem', 
            color: 'rgba(255,255,255,0.95)',
            margin: 0,
            paddingRight: '60px',
            fontWeight: '400'
          }}>
            الموافقة على طلبات المستخدمين الجدد للانضمام إلى نظام المعامل
          </p>
        </div>
        
        <div style={{ textAlign: 'center', padding: '50px', color: '#7f8c8d' }}>
          <div style={{ fontSize: '3rem', marginBottom: '20px' }}>⏳</div>
          <p>جاري التحميل...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="personnel-container">
      <div style={{ marginBottom: '30px', display: 'flex', justifyContent: 'center' }}>
        <button 
          onClick={() => navigate('/personnel')} 
          style={{
            background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)',
            border: 'none',
            color: 'white',
            padding: '16px 40px',
            borderRadius: '12px',
            fontSize: '1.2rem',
            fontWeight: '700',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 15px rgba(52, 152, 219, 0.3)',
            minWidth: '250px',
            justifyContent: 'center'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-3px) translateX(5px)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(52, 152, 219, 0.4)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0) translateX(0)';
            e.currentTarget.style.boxShadow = '0 4px 15px rgba(52, 152, 219, 0.3)';
          }}
        >
          <span style={{ fontSize: '1.4rem' }}>←</span>
          <span>العودة للأفراد</span>
        </button>
      </div>

      <div style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '40px',
        borderRadius: '15px',
        marginBottom: '30px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.15)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '10px' }}>
          <span style={{ fontSize: '2.5rem' }}>🔔</span>
          <h1 style={{ 
            fontSize: '2.2rem', 
            fontWeight: '700', 
            color: 'white',
            margin: 0,
            letterSpacing: '0.5px'
          }}>
            طلبات الانضمام
          </h1>
        </div>
        <p style={{ 
          fontSize: '1.1rem', 
          color: 'rgba(255,255,255,0.95)',
          margin: 0,
          paddingRight: '60px',
          fontWeight: '400'
        }}>
          الموافقة على طلبات المستخدمين الجدد للانضمام إلى نظام المعامل
        </p>
      </div>

      {pendingUsers.length === 0 ? (
        <div className="coming-soon">
          <div className="coming-soon-icon">✅</div>
          <h2>لا توجد طلبات معلقة</h2>
          <p>جميع الطلبات تمت معالجتها</p>
        </div>
      ) : (
        <div className="project-info">
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            marginBottom: '25px'
          }}>
            <h3 style={{ margin: 0, fontSize: '1.4rem', color: '#2c3e50' }}>
              الطلبات المعلقة ({pendingUsers.length})
            </h3>
            {!canApprove && (
              <div style={{ 
                background: '#fff3cd', 
                color: '#856404',
                padding: '8px 16px',
                borderRadius: '6px',
                fontSize: '0.9rem'
              }}>
                ⚠️ للمشاهدة فقط
              </div>
            )}
          </div>

          <div style={{ overflowX: 'auto' }}>
            <table style={{
              width: '100%',
              borderCollapse: 'collapse',
              background: 'white',
              borderRadius: '8px',
              overflow: 'hidden'
            }}>
              <thead>
                <tr style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', borderBottom: '2px solid #667eea' }}>
                  <th style={{ padding: '15px', textAlign: 'right', color: 'white', fontWeight: '600' }}>الاسم</th>
                  <th style={{ padding: '15px', textAlign: 'right', color: 'white', fontWeight: '600' }}>الموبايل</th>
                  <th style={{ padding: '15px', textAlign: 'right', color: 'white', fontWeight: '600' }}>المحطة</th>
                  <th style={{ padding: '15px', textAlign: 'right', color: 'white', fontWeight: '600' }}>الوظيفة</th>
                  <th style={{ padding: '15px', textAlign: 'right', color: 'white', fontWeight: '600' }}>الشيفت</th>
                  {canApprove && (
                    <th style={{ padding: '15px', textAlign: 'center', color: 'white', fontWeight: '600' }}>الإجراء</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {pendingUsers.map((pendingUser, index) => (
                  <tr 
                    key={pendingUser._id}
                    style={{ 
                      borderBottom: '1px solid #f0f0f0',
                      background: index % 2 === 0 ? 'white' : '#fafafa',
                      transition: 'background 0.2s ease'
                    }}
                  >
                    <td style={{ padding: '15px', color: '#2c3e50', fontWeight: '500' }}>
                      {pendingUser.fullName}
                    </td>
                    <td style={{ padding: '15px', color: '#7f8c8d', direction: 'ltr', textAlign: 'right' }}>
                      {pendingUser.phone}
                    </td>
                    <td style={{ padding: '15px', color: '#7f8c8d' }}>
                      {pendingUser.station}
                    </td>
                    <td style={{ padding: '15px' }}>
                      <span style={{
                        background: '#e3f2fd',
                        color: '#1976d2',
                        padding: '5px 12px',
                        borderRadius: '20px',
                        fontSize: '0.85rem',
                        fontWeight: '500'
                      }}>
                        {getRoleLabel(pendingUser.role)}
                      </span>
                    </td>
                    <td style={{ padding: '15px', color: '#7f8c8d' }}>
                      {pendingUser.shift}
                    </td>
                    {canApprove && (
                      <td style={{ padding: '15px' }}>
                        <div style={{ 
                          display: 'flex', 
                          gap: '10px', 
                          justifyContent: 'center' 
                        }}>
                          <button
                            onClick={() => handleApprove(pendingUser._id)}
                            disabled={processingId === pendingUser._id}
                            style={{
                              background: processingId === pendingUser._id ? '#95a5a6' : '#27ae60',
                              color: 'white',
                              border: 'none',
                              padding: '8px 20px',
                              borderRadius: '6px',
                              cursor: processingId === pendingUser._id ? 'not-allowed' : 'pointer',
                              fontSize: '0.9rem',
                              fontWeight: '500',
                              transition: 'all 0.3s ease',
                              opacity: processingId === pendingUser._id ? 0.6 : 1
                            }}
                            onMouseOver={(e) => {
                              if (processingId !== pendingUser._id) {
                                e.target.style.background = '#229954';
                                e.target.style.transform = 'translateY(-2px)';
                              }
                            }}
                            onMouseOut={(e) => {
                              if (processingId !== pendingUser._id) {
                                e.target.style.background = '#27ae60';
                                e.target.style.transform = 'translateY(0)';
                              }
                            }}
                          >
                            {processingId === pendingUser._id ? '⏳ جاري المعالجة...' : '✓ قبول'}
                          </button>
                          <button
                            onClick={() => handleReject(pendingUser._id)}
                            disabled={processingId === pendingUser._id}
                            style={{
                              background: processingId === pendingUser._id ? '#95a5a6' : '#e74c3c',
                              color: 'white',
                              border: 'none',
                              padding: '8px 20px',
                              borderRadius: '6px',
                              cursor: processingId === pendingUser._id ? 'not-allowed' : 'pointer',
                              fontSize: '0.9rem',
                              fontWeight: '500',
                              transition: 'all 0.3s ease',
                              opacity: processingId === pendingUser._id ? 0.6 : 1
                            }}
                            onMouseOver={(e) => {
                              if (processingId !== pendingUser._id) {
                                e.target.style.background = '#c0392b';
                                e.target.style.transform = 'translateY(-2px)';
                              }
                            }}
                            onMouseOut={(e) => {
                              if (processingId !== pendingUser._id) {
                                e.target.style.background = '#e74c3c';
                                e.target.style.transform = 'translateY(0)';
                              }
                            }}
                          >
                            {processingId === pendingUser._id ? '⏳ جاري المعالجة...' : '✕ رفض'}
                          </button>
                        </div>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default Approvals;